<ng-container *ngIf="ngTemplateName; else defaultTemplate">
  <ng-container>
    <form [formGroup]="searchFormGroup">
      <ng-container *ngIf="this._filterColumn && this._filterColumn.length > 0">
        <fpx-text-box class="search-bar" [placeholder]="searchPlaceholder" formControlName="templateSearch">
        </fpx-text-box>
      </ng-container>
      <ng-container *ngIf=" mattabledataSource && mattabledataSource?.filteredData?.length > 0;else emptyTemplate">
        <div class="scroll-wrapper" [ngClass]="templateClass" fpxInfiniteScroll (scrollCallback)="onScroll()">
          <ng-container *ngIf="mattabledataSource">
            <ng-container *ngFor="
              let item of mattabledataSource.filteredData;
              let index = index;
              let first = first;
              let last = last
            ">
              <box class="grid-row-container" [ngClass]="{'has-actions': rowActionArray.length && !item?.isRowGroupHeader}">
                
                <box class="grid-row-item" id="gridRowItem_{{this.randomNumber}}_{{index}}" 
                  fpxClickDbclick 
                  (click)="boxClick(item,index)"
                  (doubleClick)="onboxDoubleClick(item,index)" 
                  (swipeleft)="enableSwipe && !item?.isRowGroupHeader ? swipeLeftHandler($event,index) : null" (swiperight)="enableSwipe && !item?.isRowGroupHeader ? swipeRightHandler($event,index) : null"
                  (panstart)="enableSwipe && !item?.isRowGroupHeader ? panStartHandler($event,index) : null" (panend)="enableSwipe && !item?.isRowGroupHeader ? panEndHandler($event,index) : null" 
                  (panleft)="enableSwipe && !item?.isRowGroupHeader ? panLeftHandler($event,index) : null" (panright)="enableSwipe && !item?.isRowGroupHeader ? panRightHandler($event,index) : null" 
                  (touchstart)="enableSwipe && !item?.isRowGroupHeader ? touchStartHandler($event,index) : null">
                  <ng-container [ngTemplateOutlet]="getTemplate(ngTemplateName)" [ngTemplateOutletContext]="{
                    $implicit: item,
                    index: index,
                    first: first,
                    last: last,
                    selectedData : _selectedData
                  }">
                  </ng-container>
                </box>

                <box class="grid-row-action-item" *ngIf="!item?.isRowGroupHeader">
                  <ng-container *ngFor="let action of rowActionArray">
                    <button type="button" [class]="action.cssClass" [innerHTML]="action.name"
                    appDebounceClick (debounceClick)="rowActionClick(item, index, action.action)" [debounceTime]="1000" ></button>
                  </ng-container>
                </box>

              </box>

            </ng-container>
          </ng-container>
        </div>
    </ng-container>
    </form>
  </ng-container>
  <ng-template #emptyTemplate>
    <ng-container *ngIf="!loading">
      <div class="row-not-found">
        <div class="row-not-found-image">
          <img class="no-data-img" src="./assets/images/empty-transactions.svg" id="leftImg" alt="image1" />
        </div>
        <div class="no-notifi-text-empty">No Details Available</div>
      </div>
    </ng-container>
  </ng-template>
</ng-container>
<ng-container *ngIf="loading">
  <div [style.width]="gridWidth + '%'" class="data-loading">
    <img src="./assets/images/data-loader.svg" alt="loading_svg" />
  </div>
</ng-container>
<ng-template #defaultTemplate>
  <div class="ro-grid-header" [style.width]="gridWidth + '%'">
    <span class="title">{{ title | translate }} </span>
    <span class="spacer"> </span>
    <div class="icon-wrapper" [style.width]="gridWidth">
      <ng-container *ngFor="let toolBar of toolBarConfig">
        <ng-container [ngSwitch]="toolBar.type">
          <ng-container *ngSwitchCase="'icon'">
            <div [ngClass]="
                (toolBar.required
                | fpxtoolbardisable: toolBar.name:_selectedData)
                  ? 'disable'
                  : ''
              " class="header-icon">
              <mat-icon class="ro-grid-header__icon" (click)="onToolBarClick(toolBar.name)"
                [title]="toolBar.hoverText">{{ toolBar.key }}</mat-icon>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'button'">
            <button class="btn-link" type="button" [title]="toolBar.hoverText" (click)="onToolBarClick(toolBar.name)">
              {{ toolBar.key }}
            </button>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <div class="table-container">
    <form [formGroup]="searchFormGroup">
      <table class="table-wrapper" [style.width]="gridWidth + '%'" mat-table [dataSource]="mattabledataSource">
        <ng-container *ngFor="let col of displaycolumndefs" matColumnDef="{{ col.columnDef }}">
          <th class="table-header" [style.width]="col.width ? col.width + '% !important' : 'auto'" mat-header-cell
            *matHeaderCellDef>
            <ng-container *ngIf="col.action; else noSortSearch">
              <app-search-sort-ro-gird [formControlName]="col.columnDef" [col]="col">
              </app-search-sort-ro-gird>
            </ng-container>
            <ng-template #noSortSearch>
              <div class="table-header-wrapper">
                <span class="table-header__text">{{
                  col.header | translate
                  }}</span>
              </div>
            </ng-template>
          </th>
          <td class="table-content" mat-cell *matCellDef="let element">
            <ng-container *ngIf="col.columnDef !== 'ACTIONS'; else actionColumn">
              <ng-container *ngIf="col.cell; else keyTemplate">
                <span class="table-content__text" [innerHTML]="col.cell(element)"></span>
              </ng-container>
              <ng-template #keyTemplate>
                <span class="table-content__text" [innerHTML]="element[col.columnDef]"></span>
              </ng-template>
            </ng-container>
            <ng-template #actionColumn>
              <ng-container *ngFor="let action of cellActionArray">
                <ng-container [ngSwitch]="action.type">
                  <ng-container *ngSwitchCase="'icon'">
                    <mat-icon [class]="action.cssClass" [ngClass]="
                        (action.required
                        | fpxtoolbardisable: action.columnDef:element)
                          ? 'disable'
                          : ''
                      " [innerHTML]="action.name"></mat-icon>
                  </ng-container>
                  <ng-container *ngSwitchCase="'button'">
                    <button [class]="action.cssClass" [disabled]="
                        (action.required
                        | fpxtoolbardisable: action.columnDef:element)
                          ? 'disable'
                          : ''
                      " [innerHTML]="action.name"></button>
                  </ng-container>
                  <ng-container *ngSwitchCase="'link'">
                    <a [class]="action.cssClass" [ngClass]="
                        (action.required
                        | fpxtoolbardisable: action.columnDef:element)
                          ? 'disable'
                          : ''
                      " [innerHTML]="action.name"></a>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-template>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr [style.display]="!loading ? '' : 'none'" [ngClass]="{ 'row-selected': row.id === selectedRowId }"
          fpxClickDbclick (onclick)="onClick($event, row)" (doubleClick)="onDoubleClick($event, row)" mat-row
          *matRowDef="let row; columns: displayedColumns"></tr>
        <tr [style.display]="!loading ? '' : 'none'" #tableRow class="mat-row" *matNoDataRow>
          <td class="table-content text-center" [attr.colspan]="displayedColumns.length">
            <span class="table-content__text">{{
              "FPXROGRID.norecords" | translate
              }}</span>
          </td>
        </tr>
      </table>
      <ng-container *ngIf="loading">
        <div [style.width]="gridWidth + '%'" class="table-spinner">
          <img src="./assets/images/data-loader.svg" alt="loading_svg" />
        </div>
      </ng-container>
    </form>
  </div>
  <div class="table-footer">
    <div *ngIf="showPagination && visiblePages.length > 0" class="table-pagination">
      <div (click)="onFirstPage()" [ngClass]="pageCount - 1 === 0 ? 'pagination-disable' : ''"
        class="pagination-content">
        <mat-icon>keyboard_double_arrow_left</mat-icon>
      </div>
      <div (click)="onBack(pageCount - 1)" [ngClass]="pageCount - 1 === 0 ? 'pagination-disable' : ''"
        class="pagination-content">
        <mat-icon>navigate_before</mat-icon>
      </div>
      <ng-container *ngFor="let pageIndex of visiblePages">
        <div (click)="onPageIndex(pageIndex)" [ngClass]="pageCount === pageIndex ? 'active-index' : ''"
          class="pagination-content">
          {{ pageIndex }}
        </div>
      </ng-container>
      <div (click)="onNext(pageCount + 1)" [ngClass]="
          visiblePages.length === pageCount ||
          pageCount + 1 !== visiblePages.length
            ? 'pagination-disable'
            : ''
        " class="pagination-content">
        <mat-icon>navigate_next</mat-icon>
      </div>
      <div (click)="onLastPage()" [ngClass]="
          visiblePages.length === pageCount ? 'pagination-disable' : ''
        " class="pagination-content">
        <mat-icon>keyboard_double_arrow_right</mat-icon>
      </div>
    </div>
  </div>
</ng-template>